import template from 'lodash/template';
import isEmpty from 'lodash/isEmpty';
import compact from 'lodash/compact';
import isUndefined from 'lodash/isUndefined';

/**
 * Format a string and insert parameters into it.
 * @param {string} formatString Input string
 * @param {object} params Input parameters, e.g., { id: 1, name: 'Frank' }
 * @param {boolean} isUrl True when params can contain URL parameters.
 * @returns {string} Formatted string
 */
function format(formatString, params, isUrl) {
  const url = template(formatString.replace(/{([\w-]+)}/g, '<%= $1 %>'))(params);

  if (isUrl) {
    const firstOccurrenceIndex = url.indexOf('?') + 1; // Index of first occurrence of ?
    // Replace every single ? with & after the first occurrence
    return url.substr(0, firstOccurrenceIndex) + url.slice(firstOccurrenceIndex).replace(/\?/g, '&');
  }
  return url;
}

/**
 * Checks if the string is a placeholder, like "{someParam}".
 * @param {string} str Input string
 * @returns {boolean}
 */
function _isPlaceholder(str) {
  return /^{.*}$/g.test(str);
}

/**
 * Format a string and insert parameters into it, handling optional parameters.
 * @param {string} formatString Input string
 * @param {object} params Input parameters, e.g., { id: 1, name: 'Frank' }
 * @returns {string} Formatted string with optional parameters
 */
function formatOptional(formatString, params) {
  if (formatString.includes('?')) {
    const splitParams = compact(formatString.split('?')[1].split('&'));
    const realParams = splitParams.filter((param) => {
      const paramValue = param.split('=')[1];
      const placeholderKey = paramValue.slice(1, -1);
      return !(_isPlaceholder(paramValue) && (isUndefined(params[placeholderKey]) || isEmpty(String(params[placeholderKey]))));
    });

    // eslint-disable-next-line no-param-reassign
    formatString = `${formatString.split('?')[0]}?${realParams.join('&')}`;
  }

  return format(formatString, params);
}

const SimpleTmpl = {
  format,
  formatOptional,
};

export default SimpleTmpl;
